import { FriendSearchStateType } from './types';

export const friendSearchInitialState: FriendSearchStateType = {
  sex: 'male',
  friends: undefined,
  selectedUserData: undefined,
  isSelectedUserPurchased: undefined,
};
